import React from 'react';
import clsx from 'clsx';
import { ButtonBase } from '@americanexpress/dls-react';
import { IconChevronDown, IconWarning } from '@americanexpress/dls-icons';
import PropTypes from 'prop-types';
import styles from './DropdownButton.scss';
import { useConfigContext } from '../../contexts/configContext';

const DropdownButtonVariant = React.forwardRef(
  (
    {
      id, element, currentValue, onClick, isPopupOpened,
    },
    ref
  ) => {
    const { errors } = useConfigContext();
    const errorsToDisplay = errors?.join(' ');
    return (
      <>
        <ButtonBase
          id={id}
          onClick={onClick}
          className={clsx(styles.dropDownButtonVariant, 'body font-weight-normal color-text-regular width-full color-border-emphasis pad-l border', errors && styles.warning)}
          reactlytics={{ element }}
          ref={ref}
          tabIndex={0}
          aria-expanded={isPopupOpened}
          aria-describedby={`${id}-label ${id}-status-message`}
          aria-invalid={!!errors}
        >
          {currentValue}
          <IconChevronDown
            color="inherit"
            className={clsx(styles.dropdownIcon, 'color-graphic-regular')}
            isFilled={true}
            size="sm"
          />
        </ButtonBase>
        {errors && (
          <div id={`${id}-status-message`} className="color-status-graphic-critical margin-1-t">
            <IconWarning color="critical" size="md" isFilled={true} className="margin-1-r" />
            { errorsToDisplay }
          </div>
        )}
      </>
    );
  });

DropdownButtonVariant.displayName = 'DropdownButtonVariant';

DropdownButtonVariant.propTypes = {
  id: PropTypes.string,
  element: PropTypes.string,
  currentValue: PropTypes.string,
  onClick: PropTypes.func,
  isPopupOpened: PropTypes.bool.isRequired,
};

export default DropdownButtonVariant;
